var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, queryAssignedElements } from 'lit/decorators.js';
import '../progress-bar/sds-progress-bar.lit';
import { classMap } from 'lit/directives/class-map.js';
import { SdsToolbar } from '../toolbar/sds-toolbar.lit';
import { sdsCustomElement } from '../utilities/custom-components';
import { appendStylesToTheStyleRoot } from '../utilities/dom';
import { SidebarUtilities } from '../utilities/sidebar';
import stylesGlobal from './_sds-card-global.lit.scss';
import styles from './sds-card.lit.scss';
import { SidebarResizeHandler } from '../utilities/sidebar-resizing';
/**
 * Control that represents Card.
 *
 * @slot - This slot is the container for the card components
 * @slot footer - This slot is the container for the footer actions
 *
 * @tag sds-card
 */
let SdsCard = (() => {
    var _SdsCard_loading_accessor_storage, _SdsCard_init_accessor_storage, _SdsCard_toggle_accessor_storage, _SdsCard_sidebarResizable_accessor_storage, _SdsCard_sidebar_accessor_storage, _SdsCard_sidebarWidth_accessor_storage, _SdsCard_sidebarPosition_accessor_storage, _SdsCard__toolbar_accessor_storage, _SdsCard__cardSidebarResizeHandler_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-card')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _loading_decorators;
    let _loading_initializers = [];
    let _loading_extraInitializers = [];
    let _init_decorators;
    let _init_initializers = [];
    let _init_extraInitializers = [];
    let _toggle_decorators;
    let _toggle_initializers = [];
    let _toggle_extraInitializers = [];
    let _sidebarResizable_decorators;
    let _sidebarResizable_initializers = [];
    let _sidebarResizable_extraInitializers = [];
    let _sidebar_decorators;
    let _sidebar_initializers = [];
    let _sidebar_extraInitializers = [];
    let _sidebarWidth_decorators;
    let _sidebarWidth_initializers = [];
    let _sidebarWidth_extraInitializers = [];
    let _sidebarPosition_decorators;
    let _sidebarPosition_initializers = [];
    let _sidebarPosition_extraInitializers = [];
    let __toolbar_decorators;
    let __toolbar_initializers = [];
    let __toolbar_extraInitializers = [];
    var SdsCard = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            this.stylesGlobal = stylesGlobal;
            _SdsCard_loading_accessor_storage.set(this, __runInitializers(this, _loading_initializers, false));
            _SdsCard_init_accessor_storage.set(this, (__runInitializers(this, _loading_extraInitializers), __runInitializers(this, _init_initializers, false)));
            _SdsCard_toggle_accessor_storage.set(this, (__runInitializers(this, _init_extraInitializers), __runInitializers(this, _toggle_initializers, void 0)));
            _SdsCard_sidebarResizable_accessor_storage.set(this, (__runInitializers(this, _toggle_extraInitializers), __runInitializers(this, _sidebarResizable_initializers, void 0)));
            _SdsCard_sidebar_accessor_storage.set(this, (__runInitializers(this, _sidebarResizable_extraInitializers), __runInitializers(this, _sidebar_initializers, void 0)));
            _SdsCard_sidebarWidth_accessor_storage.set(this, (__runInitializers(this, _sidebar_extraInitializers), __runInitializers(this, _sidebarWidth_initializers, '')));
            _SdsCard_sidebarPosition_accessor_storage.set(this, (__runInitializers(this, _sidebarWidth_extraInitializers), __runInitializers(this, _sidebarPosition_initializers, 'right')));
            _SdsCard__toolbar_accessor_storage.set(this, (__runInitializers(this, _sidebarPosition_extraInitializers), __runInitializers(this, __toolbar_initializers, void 0)));
            _SdsCard__cardSidebarResizeHandler_accessor_storage.set(this, (__runInitializers(this, __toolbar_extraInitializers), null));
            this.handleToolbarToggle = (e) => {
                this.toggle = e.detail.toggle;
                this.setAttribute('toggle', this.toggle === 'expanded' ? 'expanded' : 'collapsed');
            };
            this.handleResize = () => {
                this.updateResponsiveClass();
            };
            this.handleOverlayClick = () => {
                // Close the sidebar when overlay is clicked
                this.sidebar = 'closed';
            };
        }
        /**
         * Indicates whether the component is in a loading state.
         * Used to show loading component.
         */
        get loading() { return __classPrivateFieldGet(this, _SdsCard_loading_accessor_storage, "f"); }
        set loading(value) { __classPrivateFieldSet(this, _SdsCard_loading_accessor_storage, value, "f"); }
        /**
         * Tracks whether the component has completed its initialization.
         */
        get init() { return __classPrivateFieldGet(this, _SdsCard_init_accessor_storage, "f"); }
        set init(value) { __classPrivateFieldSet(this, _SdsCard_init_accessor_storage, value, "f"); }
        /**
         * Stores the state or mode of a toggleable feature in the component.
         * This could be used to manage visibility or active/inactive states.
         */
        get toggle() { return __classPrivateFieldGet(this, _SdsCard_toggle_accessor_storage, "f"); }
        set toggle(value) { __classPrivateFieldSet(this, _SdsCard_toggle_accessor_storage, value, "f"); }
        /**
         * Indicates whether the component is resizable.
         * When set to true, the component can be resized by the user.
         * @attr
         */
        get sidebarResizable() { return __classPrivateFieldGet(this, _SdsCard_sidebarResizable_accessor_storage, "f"); }
        set sidebarResizable(value) { __classPrivateFieldSet(this, _SdsCard_sidebarResizable_accessor_storage, value, "f"); }
        /**
         * Represents the state of the sidebar.
         * Can be set to 'open' or 'close' to control the sidebar's visibility.
         * @attr
         */
        get sidebar() { return __classPrivateFieldGet(this, _SdsCard_sidebar_accessor_storage, "f"); }
        set sidebar(value) { __classPrivateFieldSet(this, _SdsCard_sidebar_accessor_storage, value, "f"); }
        /**
         * Specifies the current width of the sidebar in pixels.
         * Used to dynamically adjust and reflect sidebar size.
         */
        get sidebarWidth() { return __classPrivateFieldGet(this, _SdsCard_sidebarWidth_accessor_storage, "f"); }
        set sidebarWidth(value) { __classPrivateFieldSet(this, _SdsCard_sidebarWidth_accessor_storage, value, "f"); }
        /**
         * Defines the position of the sidebar in relation to the content.
         * Can be set to 'left' or 'right' (default is 'right').
         */
        get sidebarPosition() { return __classPrivateFieldGet(this, _SdsCard_sidebarPosition_accessor_storage, "f"); }
        set sidebarPosition(value) { __classPrivateFieldSet(this, _SdsCard_sidebarPosition_accessor_storage, value, "f"); }
        /**
         * A reference to the elements assigned to the `toolbar` slot.
         * These are typically instances of `SdsToolbar` components.
         */
        get _toolbar() { return __classPrivateFieldGet(this, _SdsCard__toolbar_accessor_storage, "f"); }
        set _toolbar(value) { __classPrivateFieldSet(this, _SdsCard__toolbar_accessor_storage, value, "f"); }
        get toolbar() {
            return this._toolbar;
        }
        get _cardSidebarResizeHandler() { return __classPrivateFieldGet(this, _SdsCard__cardSidebarResizeHandler_accessor_storage, "f"); }
        set _cardSidebarResizeHandler(value) { __classPrivateFieldSet(this, _SdsCard__cardSidebarResizeHandler_accessor_storage, value, "f"); }
        render() {
            appendStylesToTheStyleRoot(this, 'sds-card', this.stylesGlobal.cssText);
            return html `
            <div class="${this.getClasses()}" part="sds-card" id="sds-card">
                ${this.getLoadingBar()}
                <slot name="header"></slot>
                <slot name="toolbar" @slotchange="${() => this.updateToolbarState()}"></slot>
                <div class="sds-card__container">
                    <div
                        part="sds-card-content"
                        class="sds-card__content"
                        style="${SidebarUtilities.getContentMargin(Number(this.sidebarWidth), this.sidebar, this.sidebarPosition)}"
                    >
                        ${this.shouldShowOverlay()
                ? html `<div
                                  part="sds-card-overlay"
                                  class="sds-card-overlay"
                                  @click=${this.handleOverlayClick}
                              ></div>`
                : ''}
                        <slot></slot>
                    </div>
                    <div
                        class="sds-card__sidebar ${this.sidebarPosition === 'left'
                ? 'sds-card__sidebar--left'
                : 'sds-card__sidebar--right'}"
                        part="sds-card-sidebar"
                        style="${SidebarUtilities.getSidebarStyles(Number(this.sidebarWidth), this.sidebar, this.sidebarPosition)}"
                    >
                        ${this.renderResizeBorder()}
                        <slot name="sidebar" @slotchange="${() => this.requestUpdate()}"></slot>
                    </div>
                </div>
                <slot name="footer"></slot>
            </div>
        `;
        }
        updated(changedProperties) {
            if (changedProperties.has('toggle')) {
                this.updateToolbarState();
                this.dispatchEvent(new CustomEvent(SdsCard.CARD_TOGGLE_EVENT, { detail: { toggle: this.toggle } }));
            }
            if (changedProperties.has('sidebar')) {
                // Trigger responsive behavior when sidebar state changes
                setTimeout(() => {
                    this.updateResponsiveClass();
                }, 100);
            }
        }
        renderResizeBorder() {
            if (this.sidebarResizable) {
                return html ` <div id="resize-border" class="sds-card__sidebar-resize-border"></div>`;
            }
        }
        updateToolbarState() {
            if (!['collapsed', 'expanded'].includes(this.toggle)) {
                return;
            }
            this._toolbar.forEach((toolbar) => {
                toolbar.toggle = this.toggle;
                toolbar.removeEventListener(SdsToolbar.CARD_COLLAPSED_EVENT, this.handleToolbarToggle);
                toolbar.addEventListener(SdsToolbar.CARD_COLLAPSED_EVENT, this.handleToolbarToggle);
            });
        }
        async connectedCallback() {
            super.connectedCallback();
            if (this.hasAttribute('sidebar-resizable')) {
                await this.updateComplete;
                this._cardSidebarResizeHandler = new SidebarResizeHandler(this, () => this.sidebarPosition, () => this.sidebarWidth, width => (this.sidebarWidth = width));
                this._cardSidebarResizeHandler.initResize();
            }
            this.observeTextDirectionChanges();
            this.initResponsiveBehavior();
        }
        disconnectedCallback() {
            var _a;
            (_a = this._cardSidebarResizeHandler) === null || _a === void 0 ? void 0 : _a.destroy();
            this.cleanupResponsiveBehavior();
            super.disconnectedCallback();
        }
        initResponsiveBehavior() {
            this.updateResponsiveClass();
            // Listen for resize events
            window.addEventListener('resize', this.handleResize);
        }
        cleanupResponsiveBehavior() {
            window.removeEventListener('resize', this.handleResize);
        }
        updateResponsiveClass() {
            var _a;
            const cardElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.sds-card');
            if (!cardElement)
                return;
            const cardWidth = cardElement.offsetWidth;
            // Add/remove mobile class based on card width
            if (cardWidth <= 768) {
                cardElement.classList.add('sds-card--mobile');
            }
            else {
                cardElement.classList.remove('sds-card--mobile');
            }
            // Force re-render to update overlay visibility
            this.requestUpdate();
        }
        shouldShowOverlay() {
            var _a;
            const cardElement = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.sds-card');
            if (!cardElement)
                return false;
            const cardWidth = cardElement.offsetWidth;
            const isMobile = cardWidth <= 768;
            const isSidebarOpen = this.sidebar === 'open';
            return isMobile && isSidebarOpen;
        }
        observeTextDirectionChanges() {
            const observer = new MutationObserver(() => {
                this.requestUpdate(); // Trigger an update when the text direction changes
            });
            observer.observe(document.documentElement, { attributes: true, attributeFilter: ['dir'] });
        }
        getLoadingBar() {
            if (this.loading && !this.init) {
                return html ` <sds-progress-bar size="sm" indeterminate=""></sds-progress-bar> `;
            }
            else {
                return html ``;
            }
        }
        getClasses() {
            return classMap({
                'sds-card': true,
                'sds-card--collapsed': this.toggle === 'collapsed',
                'sds-card--sidebar-opened': this.sidebar === 'open',
            });
        }
    };
    _SdsCard_loading_accessor_storage = new WeakMap();
    _SdsCard_init_accessor_storage = new WeakMap();
    _SdsCard_toggle_accessor_storage = new WeakMap();
    _SdsCard_sidebarResizable_accessor_storage = new WeakMap();
    _SdsCard_sidebar_accessor_storage = new WeakMap();
    _SdsCard_sidebarWidth_accessor_storage = new WeakMap();
    _SdsCard_sidebarPosition_accessor_storage = new WeakMap();
    _SdsCard__toolbar_accessor_storage = new WeakMap();
    _SdsCard__cardSidebarResizeHandler_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsCard");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _loading_decorators = [property({ type: Boolean })];
        _init_decorators = [property({ type: Boolean })];
        _toggle_decorators = [property({
                type: String,
                hasChanged(newValue, oldValue) {
                    return newValue !== oldValue;
                },
            })];
        _sidebarResizable_decorators = [property({ type: Boolean, attribute: 'sidebar-resizable' })];
        _sidebar_decorators = [property({ type: String, reflect: true })];
        _sidebarWidth_decorators = [property({ type: Number, attribute: 'sidebar-width' })];
        _sidebarPosition_decorators = [property({ type: String, attribute: 'sidebar-position' })];
        __toolbar_decorators = [queryAssignedElements({ slot: 'toolbar' })];
        __esDecorate(_classThis, null, _loading_decorators, { kind: "accessor", name: "loading", static: false, private: false, access: { has: obj => "loading" in obj, get: obj => obj.loading, set: (obj, value) => { obj.loading = value; } }, metadata: _metadata }, _loading_initializers, _loading_extraInitializers);
        __esDecorate(_classThis, null, _init_decorators, { kind: "accessor", name: "init", static: false, private: false, access: { has: obj => "init" in obj, get: obj => obj.init, set: (obj, value) => { obj.init = value; } }, metadata: _metadata }, _init_initializers, _init_extraInitializers);
        __esDecorate(_classThis, null, _toggle_decorators, { kind: "accessor", name: "toggle", static: false, private: false, access: { has: obj => "toggle" in obj, get: obj => obj.toggle, set: (obj, value) => { obj.toggle = value; } }, metadata: _metadata }, _toggle_initializers, _toggle_extraInitializers);
        __esDecorate(_classThis, null, _sidebarResizable_decorators, { kind: "accessor", name: "sidebarResizable", static: false, private: false, access: { has: obj => "sidebarResizable" in obj, get: obj => obj.sidebarResizable, set: (obj, value) => { obj.sidebarResizable = value; } }, metadata: _metadata }, _sidebarResizable_initializers, _sidebarResizable_extraInitializers);
        __esDecorate(_classThis, null, _sidebar_decorators, { kind: "accessor", name: "sidebar", static: false, private: false, access: { has: obj => "sidebar" in obj, get: obj => obj.sidebar, set: (obj, value) => { obj.sidebar = value; } }, metadata: _metadata }, _sidebar_initializers, _sidebar_extraInitializers);
        __esDecorate(_classThis, null, _sidebarWidth_decorators, { kind: "accessor", name: "sidebarWidth", static: false, private: false, access: { has: obj => "sidebarWidth" in obj, get: obj => obj.sidebarWidth, set: (obj, value) => { obj.sidebarWidth = value; } }, metadata: _metadata }, _sidebarWidth_initializers, _sidebarWidth_extraInitializers);
        __esDecorate(_classThis, null, _sidebarPosition_decorators, { kind: "accessor", name: "sidebarPosition", static: false, private: false, access: { has: obj => "sidebarPosition" in obj, get: obj => obj.sidebarPosition, set: (obj, value) => { obj.sidebarPosition = value; } }, metadata: _metadata }, _sidebarPosition_initializers, _sidebarPosition_extraInitializers);
        __esDecorate(_classThis, null, __toolbar_decorators, { kind: "accessor", name: "_toolbar", static: false, private: false, access: { has: obj => "_toolbar" in obj, get: obj => obj._toolbar, set: (obj, value) => { obj._toolbar = value; } }, metadata: _metadata }, __toolbar_initializers, __toolbar_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsCard = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.CARD_TOGGLE_EVENT = 'sds.card.toggle';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsCard = _classThis;
})();
export { SdsCard };
